import { ability } from '~/common/services/AbilityClient';
import { FeaturesEnum } from '~/features/types';
import { PermissionEnum } from '~/roles/types';

export interface HomeRoute {
  name: string;
  params?: Record<string, any>;
}

export function useHomeRoute() {
  const userStore = useUserStore();

  function getHomeRoute(): HomeRoute {
    let homeRoute: HomeRoute = { name: 'dashboard' };

    const companyHasFeature = usersCompanyHasFeature([FeaturesEnum.DASHBOARDS]);
    if (
      !ability.can('Manage', 'All') &&
      (!ability.can('Read', PermissionEnum.SUMMARY_DASHBOARD) ||
        !companyHasFeature)
    ) {
      homeRoute = { name: 'ProfileUser', params: { id: userStore.id } };
    }

    return homeRoute;
  }

  return {
    getHomeRoute,
  };
}
export function usersCompanyHasFeature(features: FeaturesEnum[]) {
  const userStore = useUserStore();
  if (!userStore.company) {
    return false;
  }
  const companyData = JSON.parse(userStore.company as string);
  const companyFeatures = companyData?.features?.data;

  if (!Array.isArray(companyFeatures) || companyFeatures.length === 0) {
    return false;
  }

  const requested = new Set(features);
  for (const companyFeature of companyFeatures) {
    if (requested.has(companyFeature.name as FeaturesEnum)) {
      return true;
    }
  }
  return false;
}
